import React from "react";

const SenderReceiverInfo = ({ trackingData }) => {
  // If no orderInformation, don't render sender/receiver info
  if (!trackingData?.orderInformation) return null;

  const { senderDetails, receiverDetails, sourceLocation, destinationLocation } = trackingData.orderInformation || {};

  const safe = (value, fallback = "-") => (value !== undefined && value !== null && value !== "" ? value : fallback);
  const joinAddress = (loc) => {
    if (!loc) return "-";
    const parts = [safe(loc.address, null), safe(loc.city, null), safe(loc.state, null), safe(loc.pincode, null)];
    const filtered = parts.filter(Boolean);
    return filtered.length ? filtered.join(", ") : "-";
  };

  return (
    <div className="sender-receiver-info">
      {/* <div className="info-section">
        <h4>Sender Name</h4>
        <p>{safe(senderDetails?.sender_name)}</p>
      </div> */}
      {/* <div className="info-section">
        <h4>Receiver Name</h4>
        <p>{safe(receiverDetails?.receiver_name)}</p>
      </div> */}
      <div className="info-section">
        <h4>Source Location</h4>
        <p>{joinAddress(sourceLocation)}</p>
      </div>
      <div className="info-section">
        <h4>Destination Location</h4>
        <p>{joinAddress(destinationLocation)}</p>
      </div>
    </div>
  );
};

export default SenderReceiverInfo;
